<template>
  <div class="store-layout">
    <article class="store-page" v-show="!cityListIsShow">
      <button @click="openSelectCity">
        <span>{{ cityName }}</span
        ><i></i>
      </button>
      <div class="ui-store-wrapper">
        <ul>
          <li
            v-for="(item, index) in storeList"
            :class="{
              selected: item.store_code == confirmSelected.store.store_code
            }"
            @click="selectStore(item)"
          >
            <div>
              <div>
                <h3>{{ item.store_name }}</h3>
                <p>{{ item.address_street }}</p>
              </div>
              <i></i>
            </div>
          </li>
        </ul>
      </div>
    </article>
    <article class="city-page" v-show="cityListIsShow">
      <mt-index-list>
        <mt-index-section
          v-for="item in cityList"
          :key="item.title"
          :index="item.title"
        >
          <div
            @click="selectCity(obj)"
            v-for="(obj, index) in item.children"
            :key="obj.ID"
          >
            <mt-cell :title="obj.NAME"></mt-cell>
          </div>
        </mt-index-section>
      </mt-index-list>
    </article>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import { IndexList, IndexSection, Cell } from 'mint-ui'
import utils from '@/plugins/utils'
import { getLocation } from '@/plugins/location'

function push(target, k, v) {
  target[k] = target[k] || []
  target[k].push(v)
}

function groupBy(list, key, proc) {
  const res = {}
  list.sort((prev, next) => {
    if (prev[key].toUpperCase() > next[key].toUpperCase()) {
      return 1
    } else if (prev[key].toUpperCase() < next[key].toUpperCase()) {
      return -1
    } else {
      return 0
    }
  })
  list.forEach(o => {
    const k = proc ? proc(o[key]) : o[key]
    if (!k) {
      throw new Error('')
    }
    push(res, k, o)
  })
  return res
}

export default {
  data() {
    return {
      storeList: [],
      cityCode: '320100',
      cityName: '南京',
      cityList: [],
      cityListIsShow: false
    }
  },
  async created() {
    try {
      if (this.confirmSelected && this.confirmSelected.city.code) {
        this.cityCode = this.confirmSelected.city.code
        this.cityName = this.confirmSelected.city.name
      } else {
        const { citycode, cityname } = await getLocation()
        this.cityCode = citycode
        this.cityName = cityname.replace('市', '')
      }
    } catch (e) {}
    this.setStateCity()
    this.getStoreList(this.cityCode)
    this.getCityList()
  },
  components: {
    [IndexList.name]: IndexList,
    [IndexSection.name]: IndexSection,
    [Cell.name]: Cell
  },
  computed: {
    ...mapState(['confirmSelected'])
  },
  methods: {
    ...mapMutations(['setConfirmSelected']),
    async getStoreList(cityCode = 320100) {
      this.api = {
        storeList: `${utils.hostname(
          'activity'
        )}/activity/storeO2O/queryStoreofActivityList.do`
      }
      try {
        const results_res = await fetch(
          `${this.api.storeList}?city_code=${cityCode}`
        )
        const results_json = await results_res.json()
        if (results_json.data.length > 0) {
          const results = results_json.data

          this.storeList = results
        } else {
          this.$$toast('抱歉，未查询到门店')
          this.storeList = []
        }
      } catch (e) {
        console.log(e)
        this.$$toast('抱歉，系统异常')
      }
    },
    async getCityList() {
      const lifeCityList = sessionStorage.getItem('lifeCityList')
      if (lifeCityList) {
        this.cityList = JSON.parse(lifeCityList)
      } else {
        const res = await fetch(
          `//address.cekid.com/addressview/GetAllCityList`
        )
        const response = await res.json()
        if (response && response.errno == 0 && response.data) {
          this.setIndexList(response.data)
        }
      }
    },
    setIndexList(data) {
      const reg = /[a-z]/g
      const cityListObj = groupBy(data, 'PINYIN', s => s[0].toUpperCase())

      const cityList = Object.keys(cityListObj).sort()
      cityList.forEach(item => {
        this.cityList.push({
          title: item,
          children: cityListObj[item]
        })
      })
      sessionStorage.setItem('lifeCityList', JSON.stringify(this.cityList))
    },
    openSelectCity() {
      this.cityListIsShow = true
    },
    selectCity(obj) {
      this.cityCode = obj.ID
      this.cityName = obj.NAME
      this.setStateCity()
      this.cityListIsShow = false
      this.getStoreList(this.cityCode)
    },
    setStateCity() {
      this.setConfirmSelected({
        city: {
          code: this.cityCode,
          name: this.cityName
        }
      })
    },
    async selectStore(selecteStore) {
      // 如果切换门店，清空时间和人员
      const { store } = this.confirmSelected
      if (store && store.store_code !== selecteStore.store_code) {
        const serviceDate = this.$route.query.order_time || ''
        const spuId = this.$route.params.spuId
        const storeCode = selecteStore && selecteStore.store_code
        try {
          await this.$store.dispatch('getWorkers', {
            spuId,
            serviceDate,
            storeCode
            //districtId: areaCode,
          })
        } catch (e) {}
        this.$store.commit('setSelectedTime', '')
        this.$store.commit('setSelectedWorker', {})
      }
      this.setConfirmSelected({
        store: selecteStore
      })
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/mixin';
.store-layout {
  min-height: 100vh;
  padding: rem(24px);
  background: #f4f4f4;
  button {
    display: flex;
    align-items: center;
    border-radius: rem(16px);
    background: #ffffff;
    padding: 0 rem(24px);
    width: 100%;
    height: rem(76px);
    font-weight: 600;
    span {
      line-height: rem(40px);
    }
    i {
      display: block;
      width: rem(32px);
      height: rem(40px);
      background: url('~@/assets/images/icon_nav_arrow@3x.png') no-repeat center
        right;
      background-size: rem(18px) auto;
    }
  }
}
.ui-store-wrapper {
  position: relative;
  border-radius: rem(16px);
  margin-top: rem(24px);
  background: #fff;
  width: 100%;
  overflow: hidden;
  ul {
    li {
      padding: 0 rem(24px);
      &:last-child {
        > div {
          @include border(bottom, #000, 0);
        }
      }
      > div {
        padding: rem(30px) 0;
        @include border(bottom);
        display: flex;
        align-items: stretch;
        justify-content: space-between;
        color: #666;
        > div {
          width: rem(574px);
        }
        > i {
          display: block;
          height: 100%;
        }
        h3 {
          font-size: rem(30px);
          color: #333333;
          line-height: rem(36px);
          font-weight: 500;
        }
        p {
          font-size: rem(26px);
          padding-top: rem(16px);
          line-height: rem(32px);
          @include ellicpsis;
        }
      }
      &.selected {
        background: #fff3ed;
        i {
          display: block;
          width: rem(46px);
          height: rem(100px);
          background: url('~@/assets/images/icon-store_active@3x.png') no-repeat
            center right;
          background-size: rem(36px) auto;
        }
      }
    }
  }
}
</style>
